import { Translations } from "src/utils/types";
import { isValidIsraeliID } from "src/utils/utils";

const getValidationRules = (strings: Translations) => ({
  email: {
    required: strings.t_update_contact_validation_required,
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: strings.t_update_contact_validation_wrong_email,
    },
  },
  address: {
    required: strings.t_update_contact_validation_required,
    minLength: {
      value: 5,
      message: strings.t_update_contact_validation_short_address,
    },
  },
  city: {
    required: strings.t_update_contact_validation_required,
  },
  apartment: {
    required: strings.t_update_contact_validation_required,
    pattern: {
      value: /^[0-9]*$/,
      message: strings.t_update_contact_validation_wrong_apartment,
    },
    maxLength: {
      value: 4,
      message: strings.t_update_contact_validation_wrong_apartment_max_length,
    },
  },
  zip: {
    pattern: {
      value: /^\d{7}$/,
      message: strings.t_update_contact_validation_wrong_zip,
    },
    maxLength: {
      value: 7,
      message: strings.t_update_contact_validation_wrong_zip,
    },
  },
  passportNumber: {
    required: strings.t_tax_refaund_validation_required,
    pattern: {
      value: /^[A-Z0-9]{8,9}$/,
      message: strings.t_tax_refaund_validation_wrong_passport,
    },
  },
  experationDate: {
    required: strings.t_tax_refaund_validation_required,
  },
  stateOfIssue: {
    required: strings.t_tax_refaund_validation_required,
  },
  nation: {
    required: strings.t_tax_refaund_validation_required,
  },
  id: {
    required: strings.t_login_id_error_message,
    maxLength: {
      value: 9,
      message: strings.t_login_id_error_message,
    },
    pattern: {
      value: /^[0-9]*$/,
      message: strings.t_login_id_error_message,
    },

    validate: (value: string) =>
      isValidIsraeliID(value) || strings.t_login_id_error_message,
  },
  phone: {
    required: strings.t_login_phone_error_message,
    pattern: {
      value: /^[0][5][0|1|2|3|4|5|8|9]{1}[-]{0,1}[2,3,4,5,6,7,8,9]{1}[0-9]{6}$/,
      message: strings.t_login_phone_error_message,
    },
  },
  otp: {
    required: strings.t_opt_error_message,
    pattern: {
      value: /^[0-9]{6}$/,
      message: strings.t_opt_error_message,
    },
  },
  firstName: {
    required: strings.t_login_first_name_error_message,
    pattern: {
      value: /^[a-zA-Z\s]*$/,
      message: strings.t_login_first_name_error_message,
    },
  },
  lastName: {
    required: strings.t_login_last_name_error_message,
    pattern: {
      value: /^[a-zA-Z\s]*$/,
      message: strings.t_login_last_name_error_message,
    },
  },
});

export default getValidationRules;
